/// <amd-module name="Search/Shared/Base/Stores/OrganizationInfoStore" />

import { Store } from "VSS/Reflux/Store";

export interface IOrganizationInfo {
    organizationName?: string;

    organizationUrl?: string;
}

export enum OrgSearchUrlLoadState {
    OrgSearchUrlLoadSucceed,

    OrgSearchUrlLoadFailed,

    OrgSearchUrlLoadNone
}

export interface IOrganizationInfoState {
    organizationInfo: IOrganizationInfo;

    orgSearchUrlLoadState: OrgSearchUrlLoadState;
}

export class RemoteStore extends Store {
    protected _error: any;
    protected _loading: boolean;

    constructor(changedEventName: string) {
        super(changedEventName);
        this._loading = true;
        this._error = null;
    }

    public isLoading(): boolean {
        return this._loading;
    }
    public hasError(): boolean {
        return this._error !== null;
    }

    public getError(): any {
        return this._error;
    }

    protected onError(error: any): void {
        this._error = error;
        this.emitChanged();
    }
}

export class OrganizationInfoStore extends RemoteStore {
    private _state: IOrganizationInfoState;

    constructor(changedEventName: string) {
        super(changedEventName);
        this._state = {
            organizationInfo: {},
            orgSearchUrlLoadState: OrgSearchUrlLoadState.OrgSearchUrlLoadNone
        };
    }
    public onOrganizationInfoLoaded = (organizationInfo: IOrganizationInfo): void => {
        this._state.organizationInfo = organizationInfo;
        this._state.orgSearchUrlLoadState = OrgSearchUrlLoadState.OrgSearchUrlLoadSucceed;
        this._loading = false;

        this.emitChanged();
    }

    public onOrganizationInfoLoadFailed = (organizationInfo: IOrganizationInfo): void => {
        this._state.organizationInfo = organizationInfo;
        this._state.orgSearchUrlLoadState = OrgSearchUrlLoadState.OrgSearchUrlLoadFailed;
        this.emitChanged();
    }


    public onResetOrganizationInfoLoadStatus = (): void => {
        this._state.orgSearchUrlLoadState = OrgSearchUrlLoadState.OrgSearchUrlLoadNone;
        this.emitChanged();
    }

    public isLoading(): boolean {
        return this._loading;
    }
    public get state(): IOrganizationInfoState {
        return this._state;
    }
}
